















































































































































import { App } from "@/model/App";
import { mapGetters } from "vuex";
import { StateSaveApp } from "@/store/app/types_app";
import { Messages } from "@/constants/messages";
import { launchToast } from "@/utils/toast";
import Vue from "vue";
import DropdownSelector from "@/components/DropdownSelector.vue";
import InputForm from "@/components/InputForm.vue";
import IconUploader from "@/components/IconUploader.vue";
import VideoLinks from "@/components/VideoLinks.vue";
import FileUploader from "@/components/FileUploader.vue";
import BannerUploader from "@/components/BannerUploader.vue";
import URLInput from "@/components/URLInput.vue";
import categories_list from "@/constants/categories_list";
import LoadingDestore from "@/components/LoadingDestore.vue";
import { ROUTES } from "@/constants/routes";
import AppCardPreview from "@/components/AppCardPreview.vue";

export default Vue.extend({
  name: "FormRegisterApp",
  components: {
    AppCardPreview,
    LoadingDestore,
    URLInput,
    BannerUploader,
    FileUploader,
    VideoLinks,
    IconUploader,
    InputForm,
    DropdownSelector,
  },
  data(): {
    app: App;
    mess: any;
    activeStep: number;
    saveCorrectApp: boolean;
    isLoading: boolean;
  } {
    return {
      app: {
        appName: "",
        appSummary: "",
        appDescription: "",
        appUrl: "",
        appCategories: [],
        appIcon: null,
        appBanner: null,
        appImages: [],
        appVideos: [],
      },
      mess: Messages,
      activeStep: 0,
      saveCorrectApp: false,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters(["getStateSaveApp"]),
    categoriesList() {
      return categories_list.list;
    },
  },
  methods: {
    isLastStep(): boolean {
      return this.activeStep === 2;
    },
    validateStep(step: number, next: any): void {
      if(step===0) {
        this.validateStep1(next);
      }
      if(step===1){
        this.validateStep2(next);
      }
    },
    validateStep1(next: any): void {
      const validateName = (this.$refs.input_name as any).validateField();
      const validateSummary = (this.$refs.input_summary as any).validateField();
      const validateDescription = (
        this.$refs.input_description as any
      ).validateField();
      const validateCategories = (
        this.$refs.dropdown_categories as any
      ).validateField();
      const validateURL = (this.$refs.input_url as any).validateField();
      const isAllValid =
        validateName &&
        validateSummary &&
        validateDescription &&
        validateURL &&
        validateCategories;
      if (isAllValid) {
        next.action();
      }
    },
    validateStep2(next:any):void {
      const validateIcon = (this.$refs.icon_uploader as any).validateField();
      const validateBanner = (
        this.$refs.banner_uploader as any
      ).validateField();
      if (validateIcon && validateBanner) {
        next.action();
      }
    },
    receiveIcon(event: File): void {
      this.app.appIcon = event;
    },
    receiveDropFiles(event: File[]): void {
      this.app.appImages = event;
    },
    receiveBanner(event: File): void {
      this.app.appBanner = event;
    },
    receiveVideoLinks(event: string[]): void {
      const videoLinks: string[] = event;
      let videoFormatEmbed: string[] = [];
      const baseEmbed = "https://www.youtube.com/embed/";
      videoLinks.forEach((link) => {
        if (link.includes("youtube.com")) {
          videoFormatEmbed.push(baseEmbed + link.split("v=")[1]);
        } else {
          const linkSplited = link.split("/");
          videoFormatEmbed.push(
            baseEmbed + linkSplited[linkSplited.length - 1]
          );
        }
      });

      this.app.appVideos = videoFormatEmbed;
    },
    receiveCategories(event: string[]): void {
      this.app.appCategories = event;
    },
    saveInfoRegister(): void {
        const payload = {
          app: this.app,
          sessionId: this.$store.getters.getSessionId,
        };
        this.$store.dispatch("saveApp", payload);
      },
  },
  watch: {
    getStateSaveApp: function () {
      if (this.getStateSaveApp === StateSaveApp.loading) {
        this.isLoading = true;
      } else {
        this.isLoading = false;
        const toastMessage =
          this.getStateSaveApp === StateSaveApp.success
            ? this.mess.regApp_success
            : this.mess.error_general;
        const toastType =
          this.getStateSaveApp === StateSaveApp.success
            ? "is-success"
            : "is-danger";
        launchToast(toastMessage, toastType);
        if (this.getStateSaveApp === StateSaveApp.success) {
          this.$router.push({
            name: ROUTES.DETAILS_APP.name,
            params: { name: this.app.appName },
          });
        }
      }
    },
  },
});
